import {
  is,
  or,
  not,
  filter,
  compose,
  isNil,
  pickBy,
  isEmpty,
  ifElse,
  when,
  curry,
  omit,
  unless,
  prop,
  has,
  test,
  propEq,
  map,
  keys,
  replace,
  path as rPath,
  pathEq as rPathEq,
  split,
  reduce,
  length,
  defaultTo,
  uniqBy,
  sort,
  toPairs,
  fromPairs,
  unnest as runnest,
} from 'ramda';

import moment from 'moment';

export const isNotNil = compose(not, isNil);
export const compact = ifElse(is(Array), filter(isNotNil), pickBy(isNotNil));

export const isVoid = (d) => or(isNil(d), isEmpty(d));
export const isNotVoid = compose(not, isVoid);
export const clear = ifElse(is(Array), filter(isNotVoid), pickBy(isNotVoid));

const hasType = compose(isNotVoid, prop('type'));
const omitType = compose(isNotVoid, omit(['type']), clear);
const checkType = (val) => hasType(val) && omitType(val);
export const clearExceptType = compose(
  unless(checkType, () => {
    return null;
  }),
  clear
);

export const whenIsNil = when(isNil);
export const whenNotNil = when(isNotNil);
export const withDefault = curry((def, f) =>
  compose(
    whenIsNil(() => def),
    f
  )
);
export const inBetween = curry((char, data) =>
  data.reduce((accumulator, val, idx) => {
    accumulator[idx * 2] = val;

    const charat = idx * 2 - 1;
    if (charat < 0 || idx === data.length) {
      return accumulator;
    }

    accumulator[charat] = char;
    return accumulator;
  }, [])
);

export const expandIf = (c, functor) => (c && functor()) || {};

export const date = (d, format = 'MM-DD-YYYY') =>
  (d && moment(d, format).valueOf()) || null;

export const eq = (name, value, def, data) =>
  isNotVoid(prop(name, data)) ? propEq(name, value, data) : def;

const unprefixKey = (prefix) => ([key, value]) =>
  test(new RegExp(`^${prefix}_`), key) && [
    replace(new RegExp(`${prefix}_`), '', key),
    value,
  ];

export const unprefix = curry((prefix, obj) =>
  compose(fromPairs, filter(Boolean), map(unprefixKey(prefix)), toPairs)(obj)
);

const pathSplit = split('.');

export const path = curry((str, data) => rPath(pathSplit(str), data));

export const pathOr = curry((d, str, data) =>
  defaultTo(d, rPath(pathSplit(str), data))
);

export const pathEq = curry((str, value, data) =>
  rPathEq(pathSplit(str), value, data)
);

export const hasPath = curry(
  (str, data) =>
    !!reduce(
      (acc, key) => {
        if (is(Object, acc) && has(key, acc)) {
          const next = prop(key, acc);
          if (is(Object, next) && isNotNil(next)) {
            return next;
          }
          return true;
        }
        return false;
      },
      data,
      pathSplit(str)
    )
);

const propCount = compose(length, keys);

const firstProp = compose(prop(0), keys);

export const unnest = (obj) => {
  if (typeof obj === 'object' && propCount(obj) === 1) {
    return unnest(obj[firstProp(obj)]);
  }
  return obj;
};

export const splash = compose(
  uniqBy(prop('id')),
  runnest, // beware, this is unnest from ramda.
  map(prop(1)),
  sort((a, b) => a[0] - b[0]),
  toPairs,
  defaultTo({})
);
